import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '..';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  AgritourismStatutes,
} from '../../components';
import config from '../../config';

import css from './AgritourismStatutesPage.module.css';

const AgritourismStatutesPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const tabs = [
    {
      text: intl.formatMessage({ id: 'AgritourismStatutesPage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'AgritourismStatutesPage.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'AgritourismStatutesPage.LandownerReferralTitle' }),
      selected: false,
      linkProps: {
        name: 'LandownerReferralPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'AgritourismStatutesPage.AgritourismStatutesTitle' }),
      selected: true,
      linkProps: {
        name: 'AgritourismStatutesPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.MobileTermsOfServiceTitle' }),
      selected: false,
      linkProps: {
        name: 'MobileTermsOfServicePage',
      },
    },
  ];
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'AgritourismStatutesPage.schemaTitle' },
    { siteTitle }
  );
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="AgritourismStatutesPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="AgritourismStatutesPage.heading" />
            </h1>
            <AgritourismStatutes />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

AgritourismStatutesPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const AgritourismStatutesPage = compose(
  connect(mapStateToProps),
  injectIntl
)(AgritourismStatutesPageComponent);

export default AgritourismStatutesPage;
